const selector = '.progress-comparison';
const progressSelector = '.progress-comparison__bar-fill';

function animateProgressBars(container) {
  const bars = Array.from(container.querySelectorAll(progressSelector));
  bars.forEach((bar) => {
    const progress = bar.getAttribute('data-progress');
    if (progress !== null) {
      bar.style.setProperty('--progress', `${progress}%`);
      bar.style.width = `${progress}%`;
      bar.classList.add('progress-comparison__bar-fill--animated');
    }
  });
}

function createObserver() {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll(selector).forEach(animateProgressBars);
    return;
  }

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        return;
      }

      animateProgressBars(entry.target);
      obs.unobserve(entry.target);
    });
  }, {
    threshold: 0.25,
  });

  document.querySelectorAll(selector).forEach((element) => observer.observe(element));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', createObserver);
} else {
  createObserver();
}
